<template>
	<footer class="sale-legal-footer" :class="{ 'sale-legal-footer--login': variant === 'login' }">
		<div class="sale-legal-footer__inner">
			<div class="sale-legal-footer__pay" aria-label="payment">
				<img class="sale-legal-footer__logo sale-legal-footer__logo--zfb" :src="zfbImg" alt="Alipay" />
				<img class="sale-legal-footer__logo sale-legal-footer__logo--wx" :src="wxImg" alt="WeChat Pay" />
				<img class="sale-legal-footer__logo sale-legal-footer__logo--union" :src="unionPayImg" alt="UnionPay" />
			</div>
			<nav class="sale-legal-footer__links" aria-label="legal">
				<a
					v-for="item in linkList"
					:key="item.key"
					class="sale-legal-footer__link"
					:href="item.href"
					:target="item.target || '_blank'"
					rel="noopener noreferrer"
					@click="onLinkClick(item, $event)"
				>{{ $t(item.i18nKey) }}</a>
			</nav>
		</div>
	</footer>
</template>

<script>
/**
 * 销售模块页脚：支付 logo + 法律条款外链
 */
export default {
	name: 'SaleLegalFooter',
	props: {
		/**
		 * 展示变体：login 登录页 / page 登录后业务页
		 */
		variant: {
			type: String,
			default: 'page'
		}
	},
	data() {
		return {
			zfbImg: require('@/assets/img/zfb.jpg'),
			wxImg: require('@/assets/img/wx.jpg'),
			unionPayImg: require('@/assets/img/unionPay.png'),
			linkList: [
				{
					key: 'terms',
					i18nKey: 'sale.footer.terms',
					href: '#/sale/terms',
					route: '/sale/terms',
					target: '_blank'
				},
				{
					key: 'privacy',
					i18nKey: 'sale.footer.privacy',
					href: '#/sale/privacy',
					route: '/sale/privacy',
					target: '_blank'
				},
				{
					key: 'contact',
					i18nKey: 'sale.footer.contact',
					href: '#/sale/contact',
					route: '/sale/contact',
					target: '_blank'
				},
				{
					key: 'return',
					i18nKey: 'sale.footer.return',
					href: '#/sale/returnPolicy',
					route: '/sale/returnPolicy',
					target: '_blank'
				},
				{
					key: 'ip',
					i18nKey: 'sale.footer.ip',
					href: '#/sale/intellectualProperty',
					route: '/sale/intellectualProperty',
					target: '_blank'
				}
			]
		}
	},
	methods: {
		/**
		 * 站内法律页新窗口打开；外链保持默认行为
		 * @param {{ key: string, route?: string, href: string }} item
		 * @param {MouseEvent} event
		 */
		onLinkClick(item, event) {
			if (!item || !item.route) {
				return
			}
			event.preventDefault()
			var routeData = this.$router.resolve({ path: item.route })
			window.open(routeData.href, '_blank')
		}
	}
}
</script>

<style scoped>
.sale-legal-footer {
	flex-shrink: 0;
	width: 100%;
	background: #fff;
	border-top: 1px solid #e8eef5;
	box-sizing: border-box;
}

.sale-legal-footer--login {
	background: rgba(255, 255, 255, 0.92);
	border-top: 1px solid rgba(232, 238, 245, 0.9);
	backdrop-filter: blur(4px);
}

.sale-legal-footer__inner {
	max-width: 1200px;
	margin: 0 auto;
	padding: 14px 20px 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	box-sizing: border-box;
}

.sale-legal-footer__pay {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
}

.sale-legal-footer__logo {
	width: auto;
	display: block;
	object-fit: contain;
}

.sale-legal-footer__logo--zfb {
	height: 36px;
}

.sale-legal-footer__logo--wx {
	height: 57px;
}

.sale-legal-footer__logo--union {
	height: 48px;
}

.sale-legal-footer__links {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: 6px 0;
}

.sale-legal-footer__link {
	position: relative;
	padding: 0 12px;
	font-size: 12px;
	line-height: 18px;
	color: #5f6f82;
	text-decoration: none;
	white-space: nowrap;
	transition: color 0.2s ease;
}

.sale-legal-footer__link:not(:last-child)::after {
	content: '';
	position: absolute;
	right: 0;
	top: 50%;
	width: 1px;
	height: 10px;
	margin-top: -5px;
	background: #d5dee8;
}

.sale-legal-footer__link:hover {
	color: #00abfa;
}

@media (max-width: 768px) {
	.sale-legal-footer__inner {
		padding: 12px 12px 14px;
		gap: 10px;
	}

	.sale-legal-footer__logo--zfb {
		height: 32px;
	}

	.sale-legal-footer__logo--wx {
		height: 50px;
	}

	.sale-legal-footer__logo--union {
		height: 42px;
	}

	.sale-legal-footer__link {
		padding: 2px 10px;
		font-size: 11px;
		white-space: normal;
		text-align: center;
	}

	.sale-legal-footer__link:not(:last-child)::after {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/footer/SaleLegalFooter.vue